/* src/app/notify-templates/notify-template-preview/notify-template-preview.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.notify-template-preview {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  max-width: 50em;
}
.notify-template-preview .notification {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2em;
}
.notify-template-preview .cover-image {
  height: 20em;
  background-color: #e8e8e6;
}
.notify-template-preview .cover-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.notify-template-preview .tag-line {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #004791;
  font-size: 1em;
  padding: 1.5em;
  color: white;
  text-align: center;
}
.notify-template-preview .title {
  text-align: center;
  font-size: 2em;
  padding: 1em;
}
.notify-template-preview .banner-wrapper {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  padding-bottom: 2em;
  min-height: 10em;
}
.notify-template-preview .banner-wrapper .banner-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 10em;
  height: 10em;
  background-color: #d9d9d6;
  flex-shrink: 0;
  flex-grow: 0;
}
.notify-template-preview .banner-wrapper .banner-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.notify-template-preview .banner-wrapper .banner-description {
  padding: 0 1em;
}
.notify-template-preview .content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 1em;
}
@media screen and (min-width: 48rem) {
  .notify-template-preview .content-wrapper {
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
  }
}
@media screen and (min-width: 48rem) {
  .notify-template-preview .content-wrapper .content-item {
    width: 48%;
  }
}
.notify-template-preview .showcase .showcase-items {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 1em 1em 1em;
}
@media screen and (min-width: 48rem) {
  .notify-template-preview .showcase .showcase-items {
    flex-direction: row;
    justify-content: space-around;
  }
}
.notify-template-preview .showcase .showcase-items .showcase-item {
  background-color: #d9d9d6;
  width: 12em;
  height: 12em;
  margin-bottom: 2em;
}
.notify-template-preview .showcase .showcase-items .showcase-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.notify-template-preview .showcase .showcase-items + .button-placeholder {
  margin: 0 auto;
}
.notify-template-preview .messages {
  margin-top: 5em;
}
.notify-template-preview .template-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 5em;
}
.divider {
  border-top: solid thin #e8e8e6;
  display: block;
}
.key-value,
.key-value-inline {
  margin-bottom: 1em;
}
.key-value .key,
.key-value-inline .key {
  text-transform: uppercase;
}
.key-value .value,
.key-value-inline .value {
  padding-left: 1em;
}
.key-value {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
.key-value .value {
  padding-left: 0;
}
.key-value-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.remark {
  font-size: 1em;
  position: relative;
  padding-left: 1em;
  margin-top: 2em;
}
.remark::before {
  content: "*";
  position: absolute;
  top: 0;
  left: 0;
}
/*# sourceMappingURL=notify-template-preview.component.css.map */
